import { render } from "./SidebarToggle.vue?vue&type=template&id=a004b2c6&scoped=true"
import script from "./SidebarToggle.vue?vue&type=script&lang=js"
export * from "./SidebarToggle.vue?vue&type=script&lang=js"

import "./SidebarToggle.vue?vue&type=style&index=0&id=a004b2c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a004b2c6"]])

export default __exports__